import { Divider, Drawer } from '@mui/material';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import ListItems from '../../../components/ListItens'; // Atualizado para importar ListItems
import { Profile } from './components';
import useStyles from './styles';

const Sidebar = ({ className, onClose, open, variant }) => {
  const classes = useStyles();

  return (
    <Drawer anchor="left" classes={{ paper: classes.drawer }} onClose={onClose} open={open} variant={variant}>
      <div className={clsx(classes.root, className)}>
        <Profile />
        <Divider sx={{ margin: '8px 0' }} />
        <ListItems closeSidebar={onClose} /> {/* Pass closeSidebar prop */}
      </div>
    </Drawer>
  );
};

Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired
};

export default Sidebar;
